import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { ModalProvider } from "react-modal-hook";

import './src/styles/main.css';

import { ApplicationProvider } from './src/contexts/application';
import { getLayout as getDocsLayout } from './src/components/Layout/Docs';
import { getLayout as getLpLayout } from './src/components/Layout/LP';
import { getLayout as getVanillaLayout } from './src/components/Layout/Vanilla';
import { NavigationProvider } from './src/contexts/navigation';

export { default as onInitialClientRender } from './src/gatsby/browser/onInitialClientRender';
export { default as onRouteUpdate } from './src/gatsby/browser/onRouteUpdate';

export const wrapPageElement = ({ element, props }) => {
  const { location, pageContext } = props;

  const getLayout = (layout) => {
    switch (layout) {
      case 'docs':
        return getDocsLayout(props, element);
      case 'lp':
        return getLpLayout(props, element);
      case 'vanilla':
      default:
        return getVanillaLayout(props, element);
    }
  };

  return (
    <ApplicationProvider>
      <CookiesProvider>
        <NavigationProvider currentPath={location.pathname}>
          <ModalProvider>
            {getLayout(pageContext.layout)}
          </ModalProvider>
        </NavigationProvider>
      </CookiesProvider>
    </ApplicationProvider>
  );
};
